import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiLock, FiEye, FiEyeOff, FiCheckCircle, FiAlertTriangle } from 'react-icons/fi';
import '../ValidarMinhaCarteira/Login.css';
import { notify } from '../../components/Notify';
import { validarTokenSenhaApi, redefinirSenhaApi } from '../../Api';
import Footer from '../../components/Footer';

export default function RedefinirSenha() {
    const { token } = useParams();
    const navigate = useNavigate();

    const [estado, setEstado] = useState('checking'); // checking | valid | invalid | done
    const [senha, setSenha] = useState('');
    const [confirma, setConfirma] = useState('');
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        validarTokenSenhaApi({ token })
            .then(res => setEstado(res?.data?.status ? 'valid' : 'invalid'))
            .catch(() => setEstado('invalid'));
    }, [token]);

    const handleSubmit = () => {
        if (loading) return;
        if (senha.length < 6) return notify('A senha deve ter ao menos 6 caracteres.');
        if (senha !== confirma) return notify('As senhas não conferem.');

        setLoading(true);
        redefinirSenhaApi({ token, senha })
            .then(res => {
                if (res?.data?.status) {
                    setEstado('done');
                } else {
                    notify(res?.data?.message || 'Não foi possível redefinir a senha.');
                    if (/inválido|expirado/i.test(res?.data?.message || '')) setEstado('invalid');
                }
            })
            .catch(() => notify('Erro ao redefinir a senha. Tente novamente.'))
            .finally(() => setLoading(false));
    };

    return (
        <>
            <div className="container">
                <div className="login-wrapper" style={{ maxWidth: 460 }}>
                    <div className="form-side" style={{ flex: 1, width: '100%' }}>
                        <div className="brand-area">
                            <img
                                src={`${process.env.PUBLIC_URL}/nomeUnae.png`}
                                alt="UNAE Estudantil"
                                style={{ height: '54px', width: 'auto' }}
                            />
                        </div>

                        {estado === 'checking' && (
                            <div style={{ textAlign: 'center', padding: '30px 0' }}>
                                <div className="spinner" style={{ borderTopColor: '#d2d122', borderColor: 'rgba(0,0,0,0.12)', margin: '0 auto' }} />
                                <p className="subtitle" style={{ marginTop: 16 }}>Validando o link…</p>
                            </div>
                        )}

                        {estado === 'invalid' && (
                            <div style={{ textAlign: 'center', padding: '14px 0' }}>
                                <FiAlertTriangle size={46} color="#d9534f" />
                                <h2 style={{ marginTop: 14 }}>Link inválido ou expirado</h2>
                                <p className="subtitle" style={{ marginTop: 8 }}>
                                    Este link de redefinição não é mais válido. Solicite um novo na tela de login.
                                </p>
                                <button className="btn-login" style={{ marginTop: 20 }} onClick={() => navigate('/login', { replace: true })}>
                                    Voltar para o login
                                </button>
                            </div>
                        )}

                        {estado === 'done' && (
                            <div style={{ textAlign: 'center', padding: '14px 0' }}>
                                <FiCheckCircle size={46} color="#1f9d57" />
                                <h2 style={{ marginTop: 14 }}>Senha redefinida!</h2>
                                <p className="subtitle" style={{ marginTop: 8 }}>
                                    Sua nova senha já está ativa. Use-a para acessar sua carteirinha.
                                </p>
                                <button className="btn-login" style={{ marginTop: 20 }} onClick={() => navigate('/login', { replace: true })}>
                                    Ir para o login
                                </button>
                            </div>
                        )}

                        {estado === 'valid' && (
                            <>
                                <div className="header-text">
                                    <h2 style={{ textAlign: 'center' }}>Criar nova senha</h2>
                                    <p className="subtitle" style={{ textAlign: 'center' }}>Defina uma senha com ao menos 6 caracteres.</p>
                                </div>

                                <div className="formContainer">
                                    <div className="input-container">
                                        <label htmlFor="senha">Nova senha</label>
                                        <div className="custom-input-wrapper">
                                            <input
                                                id="senha"
                                                type={show ? 'text' : 'password'}
                                                placeholder="Nova senha"
                                                value={senha}
                                                onChange={(e) => setSenha(e.target.value)}
                                                style={{ paddingRight: '44px' }}
                                            />
                                            <span className="input-icon"><FiLock size={20} /></span>
                                            <button type="button" className="senha-toggle" onClick={() => setShow(s => !s)} aria-label="Mostrar senha">
                                                {show ? <FiEyeOff size={19} /> : <FiEye size={19} />}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="input-container">
                                        <label htmlFor="confirma">Confirmar senha</label>
                                        <div className="custom-input-wrapper">
                                            <input
                                                id="confirma"
                                                type={show ? 'text' : 'password'}
                                                placeholder="Repita a senha"
                                                value={confirma}
                                                onChange={(e) => setConfirma(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                                            />
                                            <span className="input-icon"><FiLock size={20} /></span>
                                        </div>
                                    </div>

                                    <button
                                        onClick={handleSubmit}
                                        className={`btn-login ${loading ? 'btn-loading' : ''}`}
                                        disabled={loading}
                                    >
                                        {loading ? <div className="spinner"></div> : "Redefinir senha"}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
